module.exports = __webpack_public_path__ + "img/profile.36e2037f.jpg";